export const changeFlexForMobile = (open, style, target) => {
	let timer = !open ? 600 : 0;
	setTimeout(() => {
		if (!open && document.body.clientWidth <= 800) {
			document.getElementsByClassName(style)[target].classList.add('flexDirectionRow');
		}
		else if (open && document.body.clientWidth <= 800) {
			document.getElementsByClassName(style)[target].classList.remove('flexDirectionRow');
		}
	}, timer);
};



// WEBPACK FOOTER //
// ./utils/changeFlexForMobile.js